/**
 * Разрешённые символы:
 *  - Кириллица (а-я, А-Я, ё, Ё)
 *  - Латиница (a-z, A-Z)
 *  - Цифры (0-9)
 *  - Пробел и перевод строки
 *  - Базовая пунктуация: . , : ; ! ?
 *  - Знаки: - _ + = " ' ( ) [ ] / \ * & @ # % № $ « » — – …
 */
const ALLOWED_CHARS = /[^a-zA-Zа-яА-ЯёЁ0-9 \n\-_+=:;,.?!"'()[\]/\\*&@#%№$«»—–…]/gu;

/**
 * Невидимые/служебные символы, которые внешне ничего не показывают,
 * но ломают вёрстку, шрифты и поиск.
 * - U+200B..U+200F  — zero-width space, joiners, marks
 * - U+202A..U+202E  — bidi-override (атака подменой направления текста)
 * - U+2060..U+206F  — word joiner и пр.
 * - U+FE00..U+FE0F  — variation selectors (часто хвост эмодзи)
 * - U+FEFF          — BOM
 * - U+00AD          — soft hyphen
 */
const INVISIBLE_CHARS = /[\u200B-\u200F\u202A-\u202E\u2060-\u206F\uFE00-\uFE0F\uFEFF\u00AD]/g;

/**
 * Висячие части surrogate pairs (когда эмодзи частично удалили, остаётся «битый» байт —
 * та самая «битая клетка», которую видит пользователь).
 */
const LONE_SURROGATES = /[\uD800-\uDFFF]/g;

/**
 * Чистит произвольный пользовательский ввод.
 *
 * @param {string} text — исходная строка
 * @param {object} [options]
 * @param {boolean} [options.allowNewlines=false] — оставлять ли \n
 * @param {number}  [options.maxLength]            — обрезать по длине (после фильтрации)
 * @returns {string}
 */
export function sanitizeText(text, options = {}) {
  if (text == null) return "";
  let s = String(text);

  // 1. Нормализуем Unicode (NFC) — приводим разные представления одних и тех же букв к канонической форме
  try { s = s.normalize("NFC"); } catch (_) {}

  // 2. Срезаем висячие surrogate'ы (битые клетки)
  s = s.replace(LONE_SURROGATES, "");

  // 3. Срезаем невидимые служебные
  s = s.replace(INVISIBLE_CHARS, "");

  // 4. Срезаем control characters (кроме \n если разрешён)
  s = s.replace(/[\u0000-\u0008\u000B-\u001F\u007F]/g, "");
  if (!options.allowNewlines) {
    s = s.replace(/[\n\r]/g, " ");
  }

  // 5. Главный фильтр — только символы из белого списка
  s = s.replace(ALLOWED_CHARS, "");

  // 6. Схлопываем лишние пробелы внутри строки (но НЕ \n)
  s = s.replace(/[ \t]{2,}/g, " ");

  if (options.maxLength && s.length > options.maxLength) {
    s = s.slice(0, options.maxLength);
  }

  return s;
}

/**
 * Версия для имён/фамилий — без переводов строк, без цифр и спецсимволов.
 * Только буквы, пробел, дефис, апостроф.
 */
export function sanitizeName(text, maxLength = 60) {
  if (text == null) return "";
  let s = String(text);
  try { s = s.normalize("NFC"); } catch (_) {}
  s = s.replace(LONE_SURROGATES, "");
  s = s.replace(INVISIBLE_CHARS, "");
  s = s.replace(/[^a-zA-Zа-яА-ЯёЁ \-']/gu, "");
  s = s.replace(/[ \t]{2,}/g, " ");
  if (s.length > maxLength) s = s.slice(0, maxLength);
  return s;
}